export default {
  header: {
    login: 'Inloggen',
  },
  auth: {
    user: 'Gebruiker',
    loggingIn: 'Inloggen...',
    logout: 'Uitloggen',
    loggingOut: 'Uitloggen...',
  },
  home: {
    welcome: 'Welkom bij Blinqx API Portal',
    subtitle: 'Dit is een lege pagina klaar voor ontwikkeling',
  },
  apiFilter: {
    title: 'Filters',
    searchPlaceholder: 'Zoek naar API naam, beschrijving',
    deleteFilters: 'Filters verwijderen',
    company: 'Bedrijf',
    category: 'Categorie',
    apiAccess: 'API Toegang',
    access: {
      private: 'Privé',
      public: 'Openbaar',
    },
  },
  apiPortalContent: {
    title: 'Begin met alles wat je nodig hebt om krachtige integraties te bouwen.',
    description:
      "Blader door onze beschikbare API's, compleet met documentatie, authenticatiedetails en voorbeelden. Of je nu aangepaste apps bouwt, taken automatiseert of onze services inbedt, onze API's zijn veilig, flexibel en gebruiksvriendelijk.",
  },
  apiCard: {
    containingFeatures: 'Bevat functies:',
    seeAllFeatures: 'Alle functies bekijken ({{count}})',
  },
  common: {
    loading: 'Laden...',
    error: 'Er is een fout opgetreden',
    noResults: 'Geen resultaten gevonden',
    apis: 'APIs',
    back: 'Terug',
    backToArticles: 'Terug naar artikelen lijst',
  },
  projectCard: {
    fallbackTitle: 'API Project',
    noDescription: 'Geen beschrijving beschikbaar',
    detailsTitle: 'Gegevens',
    slaTitle: 'SLA',
    contactsTitle: 'Contacten',
  },
  apiDetail: {
    fallbackTitle: 'API Details',
    notFound: 'API definitie niet gevonden',
    loadError: 'De API definitie kon niet worden geladen. Probeer het opnieuw of ga terug naar de',
    notFoundMessage:
      'De gevraagde API definitie werd niet gevonden. Controleer de URL of ga terug naar de',
    mainPage: 'hoofdpagina',
    tabs: {
      features: 'Functies',
      guides: 'Handleidingen',
      specs: 'Specificaties',
      demo: 'Demo',
    },
    specsTab: {
      title: 'API Specificatie',
      loadingError: 'Kan de API specificatie niet laden. Probeer het later opnieuw.',
      noSpecAvailable: 'Geen API specificatie beschikbaar',
      noSpecMessage: 'De API specificatie is niet beschikbaar voor deze API.',
      apiIdRequired: 'API ID is vereist',
      failedToLoad: 'Kan API specificatie niet laden',
    },
    guidesTab: {
      noArticles: 'Geen artikelen beschikbaar.',
    },
    featuresTab: {
      noFeatures: 'Geen functies beschikbaar voor deze API.',
    },
  },
  footer: {
    stayInLoop: 'Blijf op de hoogte!',
    description:
      'Wil je op de hoogte blijven van alle Blinqx ontwikkelingen? Abonneer je op onze nieuwsbrief en volg ons op sociale media!',
    companyInfo: {
      name: 'BLINQX',
      address: 'Pesetastraat 46',
      city: '2991 XT Barendrecht',
      email: 'hello@blinqx.tech',
      kvk: 'KvK 84045132',
    },
    newsletter: {
      title: 'Abonneer je op onze nieuwsbrief',
      agreement: 'Door je gegevens hier achter te laten ga je akkoord met onze',
      termsAndConditions: 'algemene voorwaarden',
      firstNamePlaceholder: 'Voornaam',
      lastNamePlaceholder: 'Achternaam',
      emailPlaceholder: 'E-mailadres',
      sendButton: 'Verzenden',
    },
    links: {
      aboutUs: 'Over ons',
      sectors: 'Sectoren',
      insights: 'Inzichten',
      vacancies: 'Vacatures',
    },
    legal: {
      copyright: '2025 alle rechten voorbehouden',
      terms: 'Algemene Voorwaarden',
      privacy: 'Privacybeleid',
      cookies: 'Cookieverklaring',
      whistleblower: 'Klokkenluidersregeling',
    },
  },
  featureDemo: {
    featureNotFound: 'Functie niet gevonden',
  },
  errors: {
    failedToFetchApiData: 'Het ophalen van API-gegevens is mislukt',
    failedToFetchApiDefinition: 'Het ophalen van API-definitie is mislukt',
  },
} as const;
